// Lib
import React from 'react';

// Components
import PageLoaderMain from './PageLoaderMain';

// Styles
// NOTE: The styles are imported in main.scss due to issues importing scss files on the server side

const PageLoader = (props) => (
    <div className="PageLoader Workspace">
        <header className="AppHeader">
            <div className="header-section header-tools" />
        </header>
        <PageLoaderMain {...props} />
    </div>
);

export default PageLoader;
